/**
 * Custom PrimeNG Theme Preset
 * Based on Aura preset with custom color configuration
 * 
 * Color Palette:
 * - Primary: Blue (główny kolor akcji - przyciski, linki)
 * - Surface: Slate (tła, karty, neutralne elementy - szarość z niebieskim odcieniem)
 * 
 * Dark Mode: Controlled by '.app-dark' class on <html> element
 * 
 * Łatwa zmiana kolorów:
 * - Primary: zamień '{blue.X}' na '{indigo.X}', '{emerald.X}', etc.
 * - Surface: zamień '{slate.X}' na '{zinc.X}', '{gray.X}', etc.
 */

import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const MyPreset = definePreset(Aura, {
  semantic: {
    // Primary color palette - używana dla głównych akcji (przyciski, linki)
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    },
    colorScheme: {
      light: {
        // Primary colors for light mode
        primary: {
          color: '{blue.600}',
          inverseColor: '#ffffff',
          hoverColor: '{blue.700}',
          activeColor: '{blue.800}'
        },
        // Surface colors for light mode - używana dla tła, kart, paneli
        surface: {
          0: '#ffffff',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.900}',
          950: '{slate.950}'
        }
      },
      dark: {
        // Primary colors for dark mode
        primary: {
          color: '{blue.400}',
          inverseColor: '{slate.950}',
          hoverColor: '{blue.300}',
          activeColor: '{blue.200}'
        },
        // Surface colors for dark mode
        surface: {
          0: '#ffffff',
          50: '{slate.950}',
          100: '{slate.900}',
          200: '{slate.800}',
          300: '{slate.700}',
          400: '{slate.600}',
          500: '{slate.500}',
          600: '{slate.400}',
          700: '{slate.300}',
          800: '{slate.200}',
          900: '{slate.100}',
          950: '{slate.50}'
        }
      }
    }
  }
});

export default MyPreset;
